module.exports = __webpack_public_path__ + "static/what-we-believe-04ee56fd740da16dc37562bc3de6b2a9.jpg";